export default __webpack_public_path__ + "static/media/detailed-export-icon.a6d34312.svg";